import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[appConfirm]'
})
export class ConfirmDirective {
    // Confirmation message
    @Input('appConfirm') message: string = 'Are you sure?';

    // Event emitted only if confirmed
    @Output() confirmed = new EventEmitter<void>();

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        if (confirm(this.message)) {
            this.confirmed.emit();
        }
    }
}
